import { MstListSearch, MstListSearchRaw } from '@libs/templates/mst';

/*
 * MstListSearchと同内容だが、MstMaintenanceTmplにおいてサブクラスが必要なため実装
 */
class CustomMstListSearch extends MstListSearch {
  private constructor(mstListSearch: MstListSearch) {
    super(
      mstListSearch.codeRange,
      mstListSearch.name,
      mstListSearch.mstSpareName01Condition,
      mstListSearch.mstSpareName02Condition,
      mstListSearch.validityStartDateCondition,
      mstListSearch.validityEndDateCondition,
      mstListSearch.mstNoteCondition,
    );
  }

  static init() {
    return new CustomMstListSearch(MstListSearch.baseInit());
  }
}

class CustomMstListSearchRaw extends MstListSearchRaw {
  private constructor(mstListSearchRaw: MstListSearchRaw) {
    super(
      mstListSearchRaw.codeRange,
      mstListSearchRaw.isCodeRangeExcluded,
      mstListSearchRaw.name,
      mstListSearchRaw.mstSpareName01,
      mstListSearchRaw.isMstSpareName01BlankOnly,
      mstListSearchRaw.mstSpareName02,
      mstListSearchRaw.isMstSpareName02BlankOnly,
      mstListSearchRaw.validityStartDateFrom,
      mstListSearchRaw.validityStartDateTo,
      mstListSearchRaw.validityEndDateFrom,
      mstListSearchRaw.validityEndDateTo,
      mstListSearchRaw.mstNote,
      mstListSearchRaw.isMstNoteBlankOnly,
    );
  }

  static fromModel(model: CustomMstListSearch) {
    return new CustomMstListSearchRaw(MstListSearchRaw.baseFromModel(model));
  }
}

export { CustomMstListSearch, CustomMstListSearchRaw };
